
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PaymentAndReceiptCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchPaymentmethodTypes();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNumber: 0,
        MasterId: '',
        CreatedBy: userId,
        isSubmit: false,
        IsType: true,
    });

    const [showBankField, setShowBankField] = useState(true);
    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('PaymentAndReceiptApi', `/MaxBillno/${branchId}/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        console.log(selectedOption);        

    };

    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('PaymentAndReceiptApi', `/Party/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setCustomerOptions(options);

            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));


        let ispaymentType = true;

        if (name === "IsType") {
            ispaymentType = value === "1";
            setSelectedPaymentType(ispaymentType);
            fetchData('PaymentAndReceiptApi', `/MaxBillno/${branchId}/${companyId}/${branchId}/${ispaymentType}`, token)
                .then((response) => response.response_data)
                .then((data) => {
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        BillNumber: data.BillNumber,
                        BillDate: formattedDate,
                        FinYear: data.FinYear,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching Max Billno:', error);
                });
        } else {

        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            CompanyId: companyId,
            BillDate: formattedDate,
            ChequeDate: formattedDate,
            // PaymentType: selectedPaymentmethodType.value,
            PaymentType: 1,
        }));
    }, []);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = invoicedeatils.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    //customer Payment Method 
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentApi', `/PaymentModes/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
                setShowBankField(true);
            }
        } catch (error) {
            console.error('Error fetching PaymentModes:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            PaymentType: selectedOption.value,
        }));
        if (["Cheque", "RTGS", "NEFT", "UPI"].includes(selectedOption.label)) {
            setShowBankField(false);
        } else {
            setShowBankField(true);
        }
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.MasterId || formData.MasterId === 0) {
            setErrorMessage('Customer is required!');
            setIsLoading(false);
            return;
        }

        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        // Validation for non-cash payment types
        if (selectedPaymentmethodType && selectedPaymentmethodType.label !== 'Cash') {
            if (!formData.ChequeNumber) {
                setErrorMessage('Reference No is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.ChequeDate) {
                setErrorMessage('Reference Date is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.chequeDetails) {
                setErrorMessage('Reference Details are required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!selectedBank) {
                setErrorMessage('Bank selection is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            BankId: selectedBank ? selectedBank.value : null,
        };



        try {
            const response = await postData('PaymentAndReceiptApi', updatedFormData, token);
            setSuccessMessage('Payment Created successfully!');
            setErrorMessage('');

            history.push('/PaymentAndReceiptIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Payment Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create Payment. Please try again.');
            setIsLoading(false);
        }
    };

    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        let amt = parseAndFix(formData.Amount);
        const GSTRate = parseAndFix(formData.GSTRate);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.IsIGST) {
            igstAmount = ((amt * GSTRate) / 100).toFixed(2);
        } else {
            cgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
            sgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
        }

        let netAmount = parseAndFix(amt) + parseAndFix(igstAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            Amount: amt,
            CGSTAmount: parseFloat(cgstAmount).toFixed(2),
            SGSTAmount: parseFloat(sgstAmount).toFixed(2),
            IGSTAmount: parseFloat(igstAmount).toFixed(2),
            RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    }, [formData.Amount, formData.GSTRate, formData.IsIGST]);

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Payment & Receipt Create
                </h6>

                <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                    <div className='w-full mb-2 flex'>

                        <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                            <input
                                type="radio"
                                name="IsType"
                                value="1"
                                checked={formData.IsType === true}
                                onChange={handleChange}
                            />
                            <span style={{ fontFamily: 'monospace', textTransform: 'uppercase', fontSize: '13px', marginLeft: '5px', fontWeight: 'bold' }}>PAYMENT</span>
                        </label>
                        <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                            <input
                                type="radio"
                                name="IsType"
                                value="0"
                                checked={formData.IsType === false}
                                onChange={handleChange}
                            />
                            <span style={{ fontFamily: 'monospace', textTransform: 'uppercase', fontSize: '13px', marginLeft: '5px', fontWeight: 'bold' }}>RECEIPT</span>
                        </label>
                    </div>
                </div>

                <div className="flex mt-8 w-full sm:w-auto">
                    <Button
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        <CheckCircleOutlineIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'bolder', marginLeft: '5px',color:'darkgreen' }}>Save</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/PaymentAndReceiptIndex",
                            state: { from: "/PaymentAndReceiptCreate" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                    >
                        <ArrowCircleLeftIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'bolder', marginLeft: '5px' }}>Back To List</b>
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Master Name
                            </label>

                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                options={customerOptions}
                                placeholder="Select Master"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Bill Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                onChange={handleChange}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Payment Mode
                            </label>

                            <Select
                                value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}  // Default to "Cash" if not selected
                                onChange={handlePaymentTypeChange}
                                options={paymentmethodOptions}
                                placeholder="PaymentOption"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2 flex items-center gap-x-2"
                                htmlFor="gstPercentage"
                            >
                                GST %
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-red-700"
                                    name="IsIGST"
                                    checked={formData.IsIGST || false}
                                    onChange={handleChange}
                                    style={{ marginLeft: '10px' }}
                                />
                                <span className="text-xs text-red-700" style={{ marginLeft: '5px' }}>IGST</span>
                            </label>
                            <select
                                className="shadow border rounded w-full py-2 px-3 text-black-700 leading-tight focus:shadow-outline"
                                name="GSTRate"
                                value={formData.GSTRate || 0}
                                onChange={handleChange}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            >
                                <option value={0}>0</option>
                                <option value={3}>3</option>
                                <option value={5}>5</option>
                                <option value={12}>12</option>
                                <option value={18}>18</option>
                                <option value={28}>28</option>
                            </select>
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount || ''}
                                onChange={handleChange}
                                type="number"
                                placeholder="Amount"
                                name='Amount'
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '35px' }}
                            />
                        </div>

                    </div>
                    <div className="flex flex-wrap items-center gap-x-4 mt-3">
                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                CGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                            </label>
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                SGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>
                            </label>
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                IGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>
                            </label>
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                R.Off : <span style={{ color: 'red', fontSize: '14px' }}>{formData.RoundOff}</span>
                            </label>
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Total : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
                            </label>
                        </div>
                    </div>
                    <div className="w-full mb-2 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Bank' : 'Bank'}
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedBank || { value: '', label: 'Select Bank' }}
                                onChange={handleBankChange}
                                options={bankOptions}
                                placeholder="Select Bank"
                                isSearchable
                                isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/6 mr-2">

                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ChequeNumber}
                                type="text"
                                placeholder=""
                                name="ChequeNumber"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)}
                                type="date"
                                placeholder=""
                                name="ChequeDate"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                                style={{ height: '35px', width: '100%' }}
                            />
                        </div>

                    </div>
                </div>
            </div>

        </div >
    );
}

export default PaymentAndReceiptCreate;
